import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Zoom from "react-medium-image-zoom";
import { Button, Grid } from "@mui/material";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// End
import { makePostRequest, makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
import moment from "moment";

import SearchIcon from "@mui/icons-material/Search";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SendIcon from "@mui/icons-material/Send";
import SortIcon from "@mui/icons-material/Sort";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import RefreshIcon from "@mui/icons-material/Refresh";
import avtarPic from "../../../assets/Images/avtarPic.png";
import Tooltip from "@mui/material/Tooltip";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import pdfImage from "../../../assets/Images/pdf.png";
import { useLocation } from "react-router-dom";
import reecordNotFound from "../../../assets/Images/noData2.gif";
import Pagination from '@mui/material/Pagination';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ComplaintsTab() {
  const [value, setValue] = React.useState(0);

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");

  const [complaintsList, setComplaintsList] = React.useState([]);
  const [activeIndex, setActiveIndex] = React.useState(null);
  const [selectedItem, setSelectedItem] = React.useState({});
  const [selectedUserObj, setSelectedUserObj] = React.useState({});
  const [complaintReplyList, setComplaintReplyList] = React.useState([]);
  const [userId, setUserId] = React.useState();
  const [Update, setUpdate] = React.useState(false);
  const [q, setQ] = React.useState("");
  const [sort, setSort] = React.useState("newtoold");
  const [showLoader, setShowLoader] = React.useState(false);
  const [upd_date] = React.useState(new Date());
  const [msgtitle, setmsgTittle] = React.useState("");
  const [errmsg, seterrmsg] = React.useState(false);
  const [status, setStatus] = React.useState(false);
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );

  const MAX_LENGTH = 100;

  const [resolvedComplaintsList, setResolvedComplaintsList] = React.useState(
    []
  );
  const [complaintNote] = React.useState();
  const location = useLocation();

  //pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(5);
  const [totalItems, setTotalItems] = React.useState(0);


  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  // const handleClickOpen = (scrollType, complaintId) => () => {
  //   setOpen(true);
  //   localStorage.setItem("complaintId", complaintId);
  //   setScroll(scrollType);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  // async function GetAllComplaints(isResolved) {
  //   setComplaintsList([]);
  //   setResolvedComplaintsList([]);
  //   setSelectedItem({});
  //   setSelectedUserObj({});
  //   setComplaintReplyList([]);
  //   makeGetRequest("complaint/getAllComplaints/" + isResolved)
  //     .then((response) => {
  //       if (response.status === 201) {
  //         if(response.data.data)
  //         {
  //         if (isResolved)
  //             setResolvedComplaintsList(response.data.data);
  //         else
  //             setComplaintsList(response.data.data);

  //             if(response.data.data.length>0)
  //                   detailsComplaints(response.data.data[0]);
  //         }

  //       }
  //     })
  //     .catch((err) => {
  //       swal("There was an error!", "more error details", "warning");
  //     });
  // }

  async function GetAllComplaints(isResolved) {
    setShowLoader(true);
    setComplaintsList([]);
    setResolvedComplaintsList([]);
    setSelectedItem({});
    setSelectedUserObj({});
    setComplaintReplyList([]);
    let bodyFormData = {
      searchq: q,
      pageNo: currentPage,
      count: itemsPerPage,
      is_resolved_flag: sort,
      status: isResolved,
    };

    await makePostRequest("complaint/complaintListing", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data.data;
          if (data.length > 0) {
            if (!isResolved) {
              setComplaintsList(data);
              detailsComplaints(response.data.data.data[0]);
              setTotalItems(response.data.data.total_records);
            } else {
              setResolvedComplaintsList(data);
              detailsComplaints(response.data.data.data[0]);
              setTotalItems(response.data.data.total_records);
            }

            // setShowLoader(false);
          }
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }
  const ResolveComplaint = async () => {
    // let complaintObj;
    await makeGetRequest(
      "complaint/getComplaintById/" + localStorage.getItem("complaintId")
    )
      .then((response) => {
        if (response.status === 201) {
          //  complaintObj=
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
    // let comlaintNote = document.getElementById("complaintNoteId").value;
    // if (comlaintNote) {
    //   complaintObj.is_resolved=false;
    //   complaintNote.
    //   makePostRequest("complaint/updateComplaint", complaintObj)
    //     .then((response) => {
    //       console.log(response);
    //       if (response.data.status === "1") {
    //         document.getElementById("complaintNoteId").value = "";
    //         // getAllComments(postid);
    //       }
    //     })
    //     .catch((err) => {
    //       swal("There was an error!", "more error details", "warning");
    //       console.log("Something went wrong!!", err);
    //     });
    // }
    // else {
    //   swal("Empty Note!", "Please add note...", "warning");
    // }
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  const detailsComplaints = async (keyinfo) => {
    seterrmsg(false);
    setSelectedItem(keyinfo);
    setActiveIndex(keyinfo.complaint_id);
    setSelectedUserObj(keyinfo.user_obj);
    localStorage.setItem("selectedComplaint", JSON.stringify(keyinfo));
    getAllComplaintReply(keyinfo.complaint_id);
  };

  async function addReply(complaintId) {
    // e.preventDefault();

    // let reply = document.getElementById("mainReply").value;
    if (msgtitle) {
      seterrmsg(false);
      var inputdata = "";
      // console.log(noticeTitle);

      inputdata = {
        complaint_id: complaintId,
        description: msgtitle,
        sender_id: localStorage.getItem("userId"),
      };
      setShowLoader(true);
      await makePostRequest("complaint/insertdiscussion", inputdata)
        .then((response) => {
          if (response.data.status === "1") {
            setmsgTittle("");
            document.getElementById("mainReply").value = "";
            getAllComplaintReply(complaintId);
            setUpdate(!Update);
            setShowLoader(false);
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      seterrmsg(true);
      // swal("Empty Reply!", "Unable to send empty reply", "warning");
    }
  }

  async function getAllComplaintReply(complaintId) {
    setShowLoader(true);
    await makeGetRequest("complaint/getComplaintDiscussionAdmin/" + complaintId)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data;
          // if (data[0].json_agg) {
          //   console.log(data[0].json_agg);
          setComplaintReplyList(data);
          setUpdate(!Update);
          // } else setTicketReplyList([]);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  // status ch

  async function handleCompStatus(cid, resolvestatus) {
    let textvar;
    let text;
    if (resolvestatus) {
      textvar = "close";
      text = `Do you really want to ${textvar} this complaint? This process can not be undone.`;
    } else {
      textvar = "re-open";
      text = `Do you really want to ${textvar} this complaint?`;
    }
    const willDelete = await swal({
      title: "Are you sure?",
      text: `${text}`,
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, I am sure!"],
    });
    if (willDelete) {
      let inputdata = {
        complaint_id: cid,
        is_resolved: resolvestatus,
        updated_at: upd_date,
      };
      await makePostRequest("complaint/updateComplaint/", inputdata)
        .then((response) => {
          if (response.data.status === "1") {
            // window.location.reload();
            setValue(0);
            GetAllComplaints(false);
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    }
  }

  const handleInputChange = (e) => {
    const inputValue = e.target.value.slice(0, 255);
    if (inputValue.trim() === "") {
      seterrmsg(true);
    } else if (inputValue.trim() !== inputValue) {
      seterrmsg(true);
    } else {
      seterrmsg(false);
    }
    setmsgTittle(inputValue);
    // seterrmsg(false);
  };

  const handleChangeTabs = (flag) => {
    setCurrentPage(1);
    setStatus(flag);
    GetAllComplaints(flag);
  };

  // const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    // if (open) {
    //   const { current: descriptionElement } = descriptionElementRef;
    //   if (descriptionElement !== null) {
    //     descriptionElement.focus();
    //   }
    // }
    setUserId(localStorage.getItem("userId"));
    if (location.state && location.state.selectedTab !== undefined) {
      setValue(location.state.selectedTab);
      GetAllComplaints(true);
    } else {
      GetAllComplaints(status);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, sort,currentPage]);

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);
  // End

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // setSort("newtoold");
  };

  // const openCompaintCont = (divId) => {
  //   var element = document.getElementById(divId);
  //   element.classList.toggle("openComClass");
  // };

  const chatExpandClick = () => {
    var element = document.getElementById("chatExpandId");
    element.classList.toggle("chatExpandedClassTicket");
  };

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = (e) => {
    setAnchorEl(null);
    if (e.currentTarget.dataset.myValue !== undefined) {
      setSort(e.currentTarget.dataset.myValue);
    }
  };
  // End

  let clkindexdoc = null;
  const urls = [];
  const [bindurls, setbindurls] = React.useState([]);
  const viewDocs = (nId, index, fileuploaded) => {
    setbindurls([]);
    urls.length = 0;
    bindurls.length = 0;
    const btn = document.getElementById("noticeSlideID" + index);
    if (btn) {
      if (clkindexdoc !== null) {
        const prevDivindex = document.getElementById(
          "noticeSlideID" + clkindexdoc
        );
        if (prevDivindex) {
          prevDivindex.classList.remove("filesDiv");
        }
      }
      btn.classList.toggle("filesDiv");
      clkindexdoc = index;
    }
    fileuploaded.forEach((item) => {
      try {
        console.log(typeof item);
        const parsedItem = JSON.parse(item);

        if (parsedItem && parsedItem.path) {
          urls.push(parsedItem.path);
        } else {
          urls.push(item);
        }
      } catch (error) {
        urls.push(item);
        console.error("Error:", error);
      }
    });
    setbindurls(urls);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label="Open Complaints"
              {...a11yProps(0)}
              onClick={() => handleChangeTabs(false)}
            />
            <Tab
              label="Resolved Complaints"
              {...a11yProps(1)}
              onClick={() => handleChangeTabs(true)}
            />
          </Tabs>
        </Box>
        {/* open tab */}
        <TabPanel value={value} index={0}>
          <div className="complaintsContents">
            <div className="ticketsMain" id="chatExpandId">
              <div className="discutionForumMain">
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <div className="">
                      <div className="visitorSearch">
                        <div className="visitorSearchDiv">
                          <SearchIcon className="visitorSearchIco" />
                          <input
                            type="text"
                            placeholder="Search By Title Or Number Or Users"
                            onChangeCapture={(e) => setQ(e.target.value)}
                          />
                          {/* <MicIcon className="visitorMicIco" /> */}
                        </div>
                        <SortIcon
                          className="visitorFilterIco"
                          aria-controls={openMenu ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={openMenu ? "true" : undefined}
                          onClick={handleClick}
                        />
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={openMenu}
                          onClose={handleCloseMenu}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          <MenuItem
                            onClick={handleCloseMenu}
                            data-my-value={"newtoold"}
                          >
                            Newest to Oldest
                          </MenuItem>
                          <MenuItem
                            onClick={handleCloseMenu}
                            data-my-value={"oldtonew"}
                          >
                            Oldest to Newest
                          </MenuItem>
                          <MenuItem
                            onClick={handleCloseMenu}
                            data-my-value={"urgent"}
                          >
                            Urgent Complaints
                          </MenuItem>
                        </Menu>
                      </div>

                      <div className="noticeTabMain">
                        <div className="noticeTbContDiv">
                          {complaintsList.length > 0 ? (
                            <>
                              {complaintsList.map((option, index) => (
                                <div
                                  key={option.complaint_id}
                                  className={
                                    option.complaint_id === activeIndex
                                      ? "parkSocityInner activeNotice"
                                      : "parkSocityInner"
                                  }
                                  onClick={() => detailsComplaints(option)}
                                  selectedItem={selectedItem}
                                >
                                  <span className="pstHead TicNo newNotLabel forBtSpac">
                                    Complaint No. {"C" + option.complaint_id}
                                  </span>

                                  <div className="parkSocityTop closeChatSelectIcoOut">
                                    <div className="parkSocityTopPro">
                                      {option.user_obj.profile_pic ? (
                                        <Zoom>
                                          <img
                                            src={option.user_obj.profile_pic}
                                          />
                                        </Zoom>
                                      ) : (
                                        <Zoom>
                                          <img
                                            alt="Remy Sharp"
                                            src={avtarPic}
                                          />
                                        </Zoom>
                                      )}
                                    </div>

                                    <div className="parkSoHeadingMain">
                                      <h4>
                                        {option.user_obj.first_name}{" "}
                                        {option.user_obj.last_name}
                                      </h4>
                                      <span>
                                        {moment(option.updated_at).format(
                                          "DD-MM-YYYY h:mm:ss A"
                                        )}
                                      </span>
                                    </div>
                                    <div className="parkWi">
                                      <b>{option.user_obj.contact_no}</b>

                                      {option.is_urgent ? (
                                        <span className="itUrgentTx">
                                          Urgent
                                        </span>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                    {/* <CloseIcon
                                      className="closeChatSelectIco"
                                    // onClick={() => handleTicketStatus(option)}
                                    /> */}
                                  </div>
                                  <div className="ticketBottOut">
                                    <div className="ticketLeft">
                                      <p className="pstHead">
                                        {option.complaint}
                                      </p>
                                      <p className="parContTx">
                                        {option.description.length >
                                          MAX_LENGTH ? (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                option.description.substring(
                                                  0,
                                                  MAX_LENGTH
                                                ) + "...",
                                            }}
                                          ></div>
                                        ) : (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: option.description,
                                            }}
                                          ></div>
                                        )}
                                      </p>
                                    </div>
                                    <div className="ticketRight">
                                      <Button
                                        className="ticketActions closeticketSt"
                                        onClick={() =>
                                          handleCompStatus(
                                            option.complaint_id,
                                            true
                                          )
                                        }
                                      >
                                        <CloseIcon />
                                        Close
                                      </Button>
                                    </div>
                                  </div>

                                  <div className="boxActions">
                                    {option?.attachment?.length > 0 && (
                                      <span
                                        onClick={() =>
                                          viewDocs(
                                            option.complaint_id,
                                            index,
                                            option.attachment
                                          )
                                        }
                                        className="downoadYourFile"
                                      >
                                        <FileDownloadIcon className="" />
                                        <span>Show Documents To Download</span>
                                      </span>
                                    )}
                                  </div>
                                  <div
                                    className="expandfilesDiv"
                                    id={"noticeSlideID" + index}
                                  >
                                    <div className="">
                                      {option?.attachment?.length > 0 && (
                                        <>
                                          {bindurls.map((opt, index) => (
                                            <div
                                              id="documentDiv"
                                              className="doqumentDiv1"
                                            >
                                              <a href={opt} target="_blank">
                                                <div className="doquView">
                                                  {opt.split(".").pop() ==
                                                    "txt" ? (
                                                    <img src={txtImage} />
                                                  ) : opt.split(".").pop() ==
                                                    "pdf" || "PDF" ? (
                                                    <img src={pdfImage} />
                                                  ) : opt.split(".").pop() ==
                                                    "docx" ||
                                                    opt.split(".").pop() ==
                                                    "doc" ? (
                                                    <img src={wordImage} />
                                                  ) : opt.split(".").pop() ==
                                                    "xls" ||
                                                    opt.split(".").pop() ==
                                                    "xlsx" ? (
                                                    <img src={excelImage} />
                                                  ) : (
                                                    <img src={opt} />
                                                  )}
                                                </div>
                                              </a>
                                            </div>
                                          ))}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </>
                          ) : (
                            // <div>No Complaints ....</div>
                            <div className="recordNotFound reduceSize">
                              <img src={reecordNotFound} />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </Grid>

                  {complaintsList.length > 0 ? (
                    <Grid item xs={12} md={6}>
                      <div className="forChatExpandMain">
                        <div className="noticeRightCont discutiomRightMain chatCloseHoverSt">
                          <div className="parkSocityInner">
                            <span className="pstHead TicNo newNotLabel forBtSpac">
                              Complaint No. {"C" + selectedItem.complaint_id}
                            </span>

                            <Tooltip title="Full View" placement="top" arrow>
                              <FullscreenIcon
                                className="chatExpand fullView"
                                onClick={chatExpandClick}
                              />
                            </Tooltip>
                            <Tooltip title="Small View" placement="top" arrow>
                              <FullscreenExitIcon
                                className="chatExpand shortView"
                                onClick={chatExpandClick}
                              />
                            </Tooltip>
                            <div className="parkSocityTop parkSocityTopForChat">
                              <div className="parkSocityTopPro">
                                {selectedUserObj.profile_pic ? (
                                  <Zoom>
                                    <img src={selectedUserObj.profile_pic} />
                                  </Zoom>
                                ) : (
                                  <Zoom>
                                    <img alt="Remy Sharp" src={avtarPic} />
                                  </Zoom>
                                )}
                              </div>
                              <div className="ticketRightHeadMain">
                                <h4>
                                  {selectedUserObj.first_name}{" "}
                                  {selectedUserObj.last_name}
                                </h4>
                                <span>
                                  {moment(selectedItem.created_at).format(
                                    "DD-MM-YYYY h:mm:ss A"
                                  )}
                                </span>
                              </div>
                              <div className="parkWi">
                                <b>{selectedUserObj.contact_no}</b>
                                {/* <span>Demo text</span> */}
                              </div>
                              {/* <CloseIcon className="closeChatIco" /> */}
                            </div>
                            {/* <div className="pstHead TicNo">
                              Complaint No. {"C" + selectedItem.complaint_id}
                            </div> */}
                            <p className="parContTx">
                              {" "}
                              {selectedItem.complaint}
                            </p>
                            <p className="discutionSmallContTx">
                              {/* <div
                          dangerouslySetInnerHTML={{
                            __html: selectedItem.description,
                          }}
                        ></div> */}
                              {selectedItem.description}
                            </p>
                          </div>
                        </div>
                        <div className="disctionBottomContMain">
                          <div className="disctionComntScrol ticketChatMain">
                            {complaintReplyList.map((key, index) => (
                              <>
                                {key.sender_id != userId ? (
                                  <div className="ticketChatLeft">
                                    <div className="parkSocityInner parkSocityInnerTicket">
                                      <div className="parkSocityTop">
                                        <div className="parkSocityTopPro">
                                          {key.user_obj.profile_pic ? (
                                            <Zoom>
                                              <img
                                                src={key.user_obj.profile_pic}
                                              />
                                            </Zoom>
                                          ) : (
                                            <Zoom>
                                              <img
                                                alt="Remy Sharp"
                                                src={avtarPic}
                                              />
                                            </Zoom>
                                          )}
                                        </div>
                                        <h4>
                                          {key.user_obj.first_name}{" "}
                                          {key.user_obj.last_name}
                                        </h4>
                                      </div>
                                      <p className="parContTx">
                                        {key.description}
                                      </p>
                                      <p className="parContTx parContTxDate">
                                        {moment(key.d_created).format(
                                          "DD/MM/YYYY h:mm:ss a"
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="ticketChatRight">
                                    <div className="parkSocityInner parkSocityInnerTicket">
                                      <div className="parkSocityTop">
                                        <div className="parkSocityTopPro">
                                          {key.user_obj.profile_pic ? (
                                            <Zoom>
                                              <img
                                                src={key.user_obj.profile_pic}
                                              />
                                            </Zoom>
                                          ) : (
                                            <Zoom>
                                              <img
                                                alt="Remy Sharp"
                                                src={avtarPic}
                                              />
                                            </Zoom>
                                          )}
                                        </div>
                                        <h4>
                                          {key.user_obj.first_name}{" "}
                                          {key.user_obj.last_name}
                                        </h4>
                                      </div>
                                      <p className="parContTx">
                                        {key.description}
                                      </p>
                                      <p className="parContTx parContTxDate">
                                        {moment(key.d_created).format(
                                          "DD/MM/YYYY h:mm:ss a"
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </>
                            ))}
                          </div>
                          <div className="typeComentOut">
                            <div className="typeComentOutIco">
                              <SendIcon
                                onClick={() =>
                                  addReply(selectedItem.complaint_id)
                                }
                              />
                              <textarea
                                className="textAriaChat"
                                value={msgtitle}
                                onChange={handleInputChange}
                                type="text"
                                id="mainReply"
                                placeholder={`Send a message to ${selectedUserObj.first_name +
                                  " " +
                                  selectedUserObj.last_name
                                  }...`}
                              />
                            </div>
                            {errmsg ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {"Required and white spaces are not allow"}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </Grid>
                  ) : (
                    <></>
                  )}
                </Grid>
              </div>
            </div>
          </div>
        </TabPanel>

        <TabPanel value={value} index={1}>
          <div className="complaintsContents">
            <div className="ticketsMain" id="chatExpandId">
              <div className="discutionForumMain">
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <div className="">
                      <div className="visitorSearch">
                        <div className="visitorSearchDiv">
                          <SearchIcon className="visitorSearchIco" />
                          <input
                            type="text"
                            placeholder="Search By Title Or Number"
                            onChangeCapture={(e) => setQ(e.target.value)}
                          />
                          {/* <MicIcon className="visitorMicIco" /> */}
                        </div>
                        <SortIcon
                          className="visitorFilterIco"
                          aria-controls={openMenu ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={openMenu ? "true" : undefined}
                          onClick={handleClick}
                        />
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={openMenu}
                          onClose={handleCloseMenu}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          <MenuItem
                            onClick={handleCloseMenu}
                            data-my-value={"newtoold"}
                          >
                            Newest to Oldest
                          </MenuItem>
                          <MenuItem
                            onClick={handleCloseMenu}
                            data-my-value={"oldtonew"}
                          >
                            Oldest to Newest
                          </MenuItem>
                          <MenuItem
                            onClick={handleCloseMenu}
                            data-my-value={"urgent"}
                          >
                            Urgent Complaints
                          </MenuItem>
                        </Menu>
                      </div>

                      <div className="noticeTabMain">
                        <div className="noticeTbContDiv">
                          {resolvedComplaintsList.length > 0 ? (
                            <>
                              {resolvedComplaintsList.map((option, index) => (
                                <div
                                  key={option.complaint_id}
                                  className={
                                    option.complaint_id === activeIndex
                                      ? "parkSocityInner activeNotice"
                                      : "parkSocityInner"
                                  }
                                  onClick={() => detailsComplaints(option)}
                                  selectedItem={selectedItem}
                                >
                                  <p className="pstHead TicNo newNotLabel forBtSpac">
                                    Complaint No. {"C" + option.complaint_id}
                                  </p>
                                  <div className="parkSocityTop closeChatSelectIcoOut">
                                    <div className="parkSocityTopPro">
                                      {option.user_obj.profile_pic ? (
                                        <Zoom>
                                          <img
                                            src={option.user_obj.profile_pic}
                                          />
                                        </Zoom>
                                      ) : (
                                        <Zoom>
                                          <img
                                            alt="Remy Sharp"
                                            src={avtarPic}
                                          />
                                        </Zoom>
                                      )}
                                    </div>

                                    <div className="parkSoHeadingMain">
                                      <h4>
                                        {option.user_obj.first_name}{" "}
                                        {option.user_obj.last_name}
                                      </h4>
                                      <span>
                                        {moment(option.updated_at).format(
                                          "DD-MM-YYYY h:mm:ss A"
                                        )}
                                      </span>
                                    </div>
                                    <div className="parkWi">
                                      <b>{option.user_obj.contact_no}</b>

                                      {option.is_urgent ? (
                                        <span className="itUrgentTx">
                                          Urgent
                                        </span>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                    {/* <CloseIcon
                                      className="closeChatSelectIco"
                                    // onClick={() => handleTicketStatus(option)}
                                    /> */}
                                  </div>

                                  <div className="ticketBottOut">
                                    <div className="ticketLeft">
                                      <p className="pstHead">
                                        {option.complaint}
                                      </p>
                                      <p className="parContTx">
                                        {option.description.length >
                                          MAX_LENGTH ? (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                option.description.substring(
                                                  0,
                                                  MAX_LENGTH
                                                ) + "...",
                                            }}
                                          ></div>
                                        ) : (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: option.description,
                                            }}
                                          ></div>
                                        )}
                                      </p>
                                    </div>

                                    <div className="ticketRight">
                                      <Button
                                        className="ticketActions closeticketSt"
                                        onClick={() =>
                                          handleCompStatus(
                                            option.complaint_id,
                                            false
                                          )
                                        }
                                      >
                                        <RefreshIcon />
                                        Reopen
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </>
                          ) : (
                            // <div>No Resolved Complaints ....</div>
                            <div className="recordNotFound reduceSize">
                              <img src={reecordNotFound} />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </Grid>
                  {resolvedComplaintsList.length > 0 && (
                    <Grid item xs={12} md={6}>
                      <div className="forChatExpandMain">
                        <div className="noticeRightCont discutiomRightMain chatCloseHoverSt">
                          <div className="parkSocityInner">
                            <div className="pstHead TicNo newNotLabel forBtSpac">
                              Complaint No. {"C" + selectedItem.complaint_id}
                            </div>
                            <Tooltip title="Full View" placement="top" arrow>
                              <FullscreenIcon
                                className="chatExpand fullView"
                                onClick={chatExpandClick}
                              />
                            </Tooltip>
                            <Tooltip title="Small View" placement="top" arrow>
                              <FullscreenExitIcon
                                className="chatExpand shortView"
                                onClick={chatExpandClick}
                              />
                            </Tooltip>
                            <div className="parkSocityTop parkSocityTopForChat">
                              <div className="parkSocityTopPro">
                                {selectedUserObj.profile_pic ? (
                                  <Zoom>
                                    <img src={selectedUserObj.profile_pic} />
                                  </Zoom>
                                ) : (
                                  <Zoom>
                                    <img alt="Remy Sharp" src={avtarPic} />
                                  </Zoom>
                                )}
                              </div>
                              <div className="ticketRightHeadMain">
                                <h4>
                                  {selectedUserObj.first_name}{" "}
                                  {selectedUserObj.last_name}
                                </h4>
                                <span>
                                  {moment(selectedItem.updated_at).format(
                                    "DD-MM-YYYY h:mm:ss A"
                                  )}
                                </span>
                              </div>
                              <div className="parkWi">
                                <b>{selectedUserObj.contact_no}</b>
                                {/* <span>Demo text</span> */}
                              </div>
                              {/* <CloseIcon className="closeChatIco" /> */}
                            </div>

                            <p className="parContTx">
                              {" "}
                              {selectedItem.complaint}
                            </p>
                            <p className="discutionSmallContTx">
                              {/* <div
                          dangerouslySetInnerHTML={{
                            __html: selectedItem.description,
                          }}
                        ></div> */}
                              {selectedItem.description}
                            </p>
                          </div>
                        </div>
                        <div className="disctionBottomContMain">
                          <div className="disctionComntScrol ticketChatMain">
                            {complaintReplyList.map((key, index) => (
                              <>
                                {key.sender_id != userId ? (
                                  <div className="ticketChatLeft">
                                    <div className="parkSocityInner parkSocityInnerTicket">
                                      <div className="parkSocityTop">
                                        <div className="parkSocityTopPro">
                                          {key.user_obj?.profile_pic ? (
                                            <Zoom>
                                              <img
                                                src={key.user_obj.profile_pic}
                                              />
                                            </Zoom>
                                          ) : (
                                            <Zoom>
                                              <img
                                                alt="Remy Sharp"
                                                src={avtarPic}
                                              />
                                            </Zoom>
                                          )}
                                        </div>
                                        <h4>
                                          {key.user_obj?.first_name}{" "}
                                          {key.user_obj?.last_name}
                                        </h4>
                                      </div>
                                      <p className="parContTx">
                                        {key.description}
                                      </p>
                                      <p className="parContTx parContTxDate">
                                        {moment(key.d_created).format(
                                          "DD/MM/YYYY h:mm:ss a"
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="ticketChatRight">
                                    <div className="parkSocityInner parkSocityInnerTicket">
                                      <div className="parkSocityTop">
                                        <div className="parkSocityTopPro">
                                          {key.user_obj?.profile_pic ? (
                                            <Zoom>
                                              <img
                                                src={key.user_obj.profile_pic}
                                              />
                                            </Zoom>
                                          ) : (
                                            <Zoom>
                                              <img
                                                alt="Remy Sharp"
                                                src={avtarPic}
                                              />
                                            </Zoom>
                                          )}
                                        </div>
                                        <h4>
                                          {key.user_obj?.first_name}{" "}
                                          {key.user_obj?.last_name}
                                        </h4>
                                      </div>
                                      <p className="parContTx">
                                        {key.description}
                                      </p>
                                      <p className="parContTx parContTxDate">
                                        {moment(key.d_created).format(
                                          "DD/MM/YYYY h:mm:ss a"
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </>
                            ))}
                          </div>
                          {/* <div className="typeComentOut">
                          <div className="typeComentOutIco">
                            <SendIcon
                              onClick={() => addReply(selectedItem.complaint_id)}
                            />
                            <input
                              type="text"
                              id="mainReply"
                              placeholder="Type text "
                            />
                          </div>
                        </div> */}
                        </div>
                      </div>
                    </Grid>
                  )}
                </Grid>
              </div>
            </div>
          </div>
        </TabPanel>
      </Box>

      <Grid container spacing={3} >
        <Grid item xs={12} md={12} >
          <Pagination count={Math.ceil(totalItems / itemsPerPage)}
            page={currentPage}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded" />
        </Grid>
      </Grid>
      {/* resolve tab */}
      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Resolved Complaint</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Grid container spacing={3} className="addCommitee1">
                  {/* <Grid item xs={12} md={12}>
                    <div className="modalInput">
                      <MailOutlineIcon />
                      <input
                        className="modalInputSt"
                        placeholder="Title of message"
                      />
                    </div>
                  </Grid> */}

                  <Grid item xs={12} md={12}>
                    <div className="modalInput">
                      <textarea
                        className="textAriaSt"
                        placeholder="Add A Note (Optional)"
                        id="complaintNoteId"
                        value={complaintNote}
                      ></textarea>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div className="atchmentMain">
                      <div className="atchMain">
                        <AttachmentOutlinedIcon />
                        <input type="file" />
                        <span>Add attachment</span>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button
                        className="modalMainBt"
                        onClick={() => ResolveComplaint()}
                      >
                        Resolved
                      </Button>
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                      <h4>Success !</h4>
                      <p>Resolved successfully</p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
